import { authRoles } from "../../../auth/authRoles";
import EditHeroSection from "./EditHeroSection";
import HeroSection from "./HeroSection";

const heroSectionRoute = [
  {
    path: "/hero_section/edit/:id",
    exact: true,
    component: EditHeroSection,
    auth: authRoles.all,
  },
  {
    path: "/hero_section",
    exact: true,
    component: HeroSection,
    auth: authRoles.all,
  },
];

export default heroSectionRoute;
